import { Cable, ShieldCheck } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import { Spinner } from '@/components/ui'
import { ModuleEmptyPage } from '@/components/layout/ModuleEmptyPage'
import { useCurrentTenant } from '@/features/tenants/useCurrentTenant'

import { IntegrationsList } from './components/IntegrationsList'

/**
 * Tela de Integracoes (o "3o cerebro" — Live Tools): o usuario ve os conectores disponiveis e, de
 * cada um, as consultas ao vivo que o agente pode fazer ao responder um cliente (dados que mudam:
 * pedidos, planos, direitos do cliente), com a saude da integracao sempre visivel. Informativa /
 * read-only hoje. Vocabulario neutro (docs/design/00 s5): nunca expoe SQL/HTTP/SDK/read model/RAG.
 */
export function IntegrationsPage() {
  const { t } = useTranslation()
  const { tenant, isLoading } = useCurrentTenant()

  if (isLoading) {
    return (
      <div className="flex justify-center py-12">
        <Spinner label={t('loading')} />
      </div>
    )
  }

  if (tenant === null) {
    return (
      <ModuleEmptyPage
        icon={Cable}
        title={t('modules.integrations.title')}
        description={t('modules.integrations.description')}
      />
    )
  }

  return (
    <div className="mx-auto flex w-full max-w-4xl flex-col gap-6">
      <header className="flex flex-col gap-1">
        <h1 className="text-xl font-semibold text-foreground-primary">
          {t('integrations.pageTitle')}
        </h1>
        <p className="text-sm text-foreground-muted">{t('integrations.pageSubtitle')}</p>
      </header>

      <div className="flex gap-3 rounded-lg border border-border-default bg-background-subtle p-4">
        <ShieldCheck
          aria-hidden="true"
          className="mt-0.5 h-5 w-5 shrink-0 text-foreground-secondary"
        />
        <div className="flex flex-col gap-1">
          <p className="text-sm font-medium text-foreground-primary">
            {t('integrations.intro.title')}
          </p>
          <p className="text-sm text-foreground-secondary">{t('integrations.intro.description')}</p>
        </div>
      </div>

      <IntegrationsList tenantId={tenant.id} />
    </div>
  )
}
